export function matchesAspectRatio(input) {
  return /^(\d)+:(\d)+$/.test(input);
}

export function isDomain(input) {
  let startsWithwww = input && input.lastIndexOf('www.', 0) === 0;
  let startsWithhttp = input && input.lastIndexOf('http://', 0) === 0;
  return !startsWithwww && !startsWithhttp && /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/.test(input);
}

export function isShorterThenMaxLength(input, maxLength) {
  return input !== null && input !== undefined && input.length <= maxLength;
}

export function numberBetween(input, minValue, maxValue) {
  return input >= minValue && input <= maxValue;
}

export function maxDailyBudgetValue(input) {
  return input <= 20000;
}

export function isInteger(input) {
  return Number.isInteger(input);
}

export function isAllNumbers(input) {
  return _.every(input, (char) => { return /^\d$/.test(char) });
}

export function twoDecimalDigitsValidator(value) {
    return /^[0-9]+(\.[0-9]{1,2})?$/.test(value);
}

export function singleEmailAddressValidator(value) {
  return /^[^@]+@[^@]+\.[^@]+$/.test(value);
}

export function multipleEmailAddressValidator(values) {
  let isValid = true;

  values.split(',')
          .forEach(v => {
            isValid = isValid && /^[^@]+@[^@]+\.[^@]+$/.test(v);
          });
  return isValid;
}

export function normalizeAutoGoalsOptimizationFields(campaign) {
  if (campaign.auto_goals_optimization === 'true') {
    campaign.auto_goals_optimization = true;
  } else if (campaign.auto_goals_optimization === 'false') {
    campaign.auto_goals_optimization = false;
  } else if (campaign.auto_goals_optimization == null) {
    campaign.auto_goals_optimization = false;
  }

  const intervalDays = parseInt(campaign.auto_goals_optimization_interval_days, 10);
  if (_.isNaN(intervalDays)) {
    campaign.auto_goals_optimization_interval_days = 3;
  } else {
    campaign.auto_goals_optimization_interval_days = Math.min(7, Math.max(1, intervalDays));
  }

  const validMethods = ['roi', 'app_open', 'conversion', 'retention'];
  if (!validMethods.includes(campaign.goals_optimization_method)) {
    campaign.goals_optimization_method = 'roi';
  }
}



/** WEBPACK FOOTER **
 ** ./src/common/util/validation-util.js
 **/